<template>
  <!-- 首页布局：Navbar → 轮播图 → 新品 → 产品类别 → 视频 → 底部声明 -->
  <div class="home" :style="{ height: totalHeightInPx + 'px' }">
    <Navbar />
    <CarouselImg :height="carouselImgHeight" />
    <!-- <NewProductImg :height="newProductImgHeight" /> -->
    <CategorieImg :height="categorieImgHeight" />
    <!-- <CarouselVideo :height="carouselVideoHeight" /> -->
    <!-- 新增区块（按顺序插入在视频轮播与底部声明之间）：
         1) 荣获奖项标题区（0.02），2) 荣获奖项图区（0.11），
         3) 工艺标题区（0.02），4) 工艺图区（0.11）。
         历史要求记录：子组件保留“标题上移”的覆盖层注释与实现，通过修改 top 百分比进行位置微调。 -->
    <!-- <AwardTitle :height="awardTitleHeight" />
    <Award :height="awardHeight" /> -->
    <!-- 临时替换：注释下方两行并取消 DistributorMap 行注释以显示地图；反之恢复原样 -->
    <!-- <CraftsmanshipTitle :height="craftsmanshipTitleHeight" />
    <Craftsmanship :height="craftsmanshipHeight" /> -->
    <DistributorMap id="distributor-map" :height="distributorMapHeight" />
    <Footer :height="footerHeight" />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import Navbar from '@/components/navbar.vue';
import CarouselImg from '@/components/carousel_img.vue';
// import NewProductImg from '@/components/new_product_img.vue';
import CategorieImg from '@/components/categorie_img.vue';
// import CarouselVideo from '@/components/carousel_video.vue';
import Footer from '@/components/footer.vue';
// import AwardTitle from '@/components/award_title.vue';
// import Award from '@/components/award.vue';
// import CraftsmanshipTitle from '@/components/craftsmanship_title.vue';
// import Craftsmanship from '@/components/craftsmanship.vue';
import DistributorMap from '@/components/DistributorMap.vue';

@Options({
  components: {
    Navbar,
    CarouselImg,
    // NewProductImg,
    CategorieImg,
    // CarouselVideo,
    // AwardTitle,
    // Award,
    // CraftsmanshipTitle,
    // Craftsmanship,
    DistributorMap,
    Footer,
  },
})
export default class HomeView extends Vue {
  // 通过一个总高度变量驱动整页各区块的高度比例
  totalHeightInPx = 3900; // 可按页面视觉需求调整

  // 更新说明（2026-03）：网页从上往下，分为这些区域：轮播区、七大品牌区、全球代理商地图区、底部声明区
  // 区域高度占比：”轮播区“0.11、”七大品牌区“0.76、全球代理商地图区“0.11，“底部声明区”0.02
  // 因底部声明区文字溢出，调整 footerHeight 占比至 0.02，categorieImgHeight 相应减少至 0.76
  get carouselImgHeight() { return this.totalHeightInPx * 0.14 }
  // get newProductImgHeight() { return this.totalHeightInPx * 0.15; }
  get categorieImgHeight() { return this.totalHeightInPx * 0.74 }
  // get carouselVideoHeight() { return this.totalHeightInPx * 0.11; }
  // 新增区块高度（总计 0.26，插入在视频与底部之间）
  // get awardTitleHeight() { return this.totalHeightInPx * 0.02; }
  // get awardHeight() { return this.totalHeightInPx * 0.11; }
  // get craftsmanshipTitleHeight() { return this.totalHeightInPx * 0.02; }
  // get craftsmanshipHeight() { return this.totalHeightInPx * 0.11; }
  get distributorMapHeight() { return this.totalHeightInPx * 0.10 }
  get footerHeight() { return this.totalHeightInPx * 0.02; }
}
</script>

<style scoped>
.home {
  margin: 0;
  padding: 0;
  /* 空样式占位：保持 window 滚动行为，不强制设定高度 */
}
</style>